import apiClient from './apiClient';

const paymentClient = apiClient('payments');

export default {
    async checkPayment(promoId) {
        const res = await paymentClient.post('check', { promoId });
        return res.data;
    },
};
